module.exports = __webpack_public_path__ + "static/placeholder-c531df328d92d1d7beec25f9944b532a.jpg";